var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.907 4.86a.152.152 0 00-.167.033l-8.122 8.12a2.292 2.292 0 01-3.24 0l-8.12-8.12a.15.15 0 00-.166-.033A.152.152 0 000 5v10a1.667 1.667 0 001.667 1.667h16.666A1.667 1.667 0 0020 15V5a.15.15 0 00-.093-.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.263 12.13a1.043 1.043 0 001.473 0l8.071-8.072a.417.417 0 00.101-.426c-.091-.274-.346-.299-.575-.299H1.667c-.23 0-.486.025-.576.3a.417.417 0 00.1.425z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.245e3b24.svg";
export { ForwardRef as ReactComponent };